module.exports = __webpack_public_path__ + "img/insert-image.1b55ba4f.svg";